import { ModuleRegistry } from "seneca-common/features/module/registry";

import { markAnswer } from "./logic/answers";
import { generateContent } from "./logic/content";

export { INITIAL_SCORE, SELECTABLE_WORD_REGEX } from "./constants";
export type {
  ContentSource,
  SelectableSentence,
  SelectableWord,
  WrongWordProps
} from "./types";

export const MODULE_TYPE = "wrong-word";
export type TYPE = "wrong-word";

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .back.staticInformation()
    .displayName("Wrong Word")
    .testOnly()
    .supportsAmeliaExplainMyAnswer()
    .root.register();
